import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../images/location_new//washington/fuel_up_back.webp";
import { Link } from "gatsby";

function Dynamichouston() {
  return (
    <section
      className="dynamic_houston p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto resp_order"
          >
            <StaticImage
              src="../../images/location_new/washington/fuel_up_washington.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={486}
              height={651}
            />
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Fuel Up Innovation With TekRevol’s Professional App Development in
              Washington DC
            </h2>
            <p>
              Tekrevol is home to several innovation-driven app developers in
              DC. We aim to create inspiring transformational digital products
              for businesses by understanding market opportunities and
              delivering elegant customer experience by leveraging emerging
              technologies.
            </p>
            <p>
              We break the conventional app development clutter by implementing
              our collaborative design and development process. Since numerous
              agencies offer mobile app development in DC., we strive to stand
              out by adding maximum value to our client’s project through our
              sound experience, and approach.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Dynamichouston;
